import { commonNextEnv } from '@repo/env/client';
import { createNavigation } from 'next-intl/navigation';
import { defineRouting } from 'next-intl/routing';
import { LOCALE_CODES, DEFAULT_LOCALE_CODE } from '../constants';

export const routing = defineRouting({
  locales: LOCALE_CODES,
  defaultLocale: DEFAULT_LOCALE_CODE,
  localePrefix: 'as-needed',
  localeCookie: { domain: `.${commonNextEnv().NEXT_PUBLIC_APP_ORIGIN_DOMAIN}` },
});

const navigation = createNavigation(routing);

export const { Link } = navigation;
export const { redirect } = navigation;
export const { usePathname: useI18nPathname } = navigation;
export const { useRouter } = navigation;
